import React, { useEffect, useState } from "react";

import { __t } from "../../utils/translate";

import Variation from "./variation";
import { GatsbyImage } from "gatsby-plugin-image";
import { LocalFile, Product } from './../../utils/types';
import { getGatsbyImageData } from "@/utils/utils";

type BundleItemProps = {
    product: Product;
    isCoupon: boolean;
    setAttributeBundle: (attribute: Record<string, unknown>) => void;
    idx: string;
    bundle: Record<string, unknown>;
};

const BundleItem: React.FC<BundleItemProps> = ({
    product,
    isCoupon,
    setAttributeBundle,
    idx,
    bundle
}) => {
    const [imageData, setImageData] = useState(getGatsbyImageData(product.image.localFile));

    const setVariation = (id, attributes) => {
        let t_var = product.variations_product.find((variation) => {
            let attributes_find = variation.attributes2.filter(attr => {
                return attributes[`bundle_attribute_` + attr.attribute + '_' + idx] == attr.value;
            })

            return attributes_find.length === variation.attributes2.length;
        });

        const variation = product.variations_product.find((variation) => variation.id === t_var.id);
        if (variation?.image?.localFile) {
            setImageData(getGatsbyImageData(variation.image.localFile));
        }
    }

    useEffect(() => {
        let itemAttributes = {};
        Object.keys(bundle).forEach(key => {
            if (key.endsWith(`_${idx}`)) {
                itemAttributes[key] = bundle[key];
            }
        });
        setVariation(idx, itemAttributes)
    }, [bundle]);

    return (
        <div className="border-b border-stroke-color mb-4 py-2">
            <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row items-start gap-4 w-[95%] sm:w-full">
                <GatsbyImage
                    alt=""
                    image={imageData}
                    className={`h-[175px] w-[175px] sm:h-[94px] sm:w-[94px] md:h-[175px] md:w-[175px] lg:h-[85px] lg:w-[85px] xl:h-[100px] xl:w-[100px] min-w-[175px] sm:min-w-[94px] md:min-w-[175px] lg:min-w-[85px] xl:min-w-[100px]`}
                    sizes="(max-width: 175px) 175px, 175px"
                />
                <div className="flex flex-col items-start w-full">
                    <div className={`flex flex-row justify-between items-center grow w-full ${isCoupon ? 'md:pr-10' : ''}`}>
                        <p className="text-title mb-2">{product.name}</p>
                        <p className="md:text-title text-base-16-strong mb-2 flex flex-row items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.35357 3.35363C9.54884 3.15835 9.54884 2.84174 9.35357 2.64646C9.15829 2.45118 8.84168 2.45118 8.6464 2.64646L5.99965 5.29321L3.35289 2.64646C3.15761 2.45118 2.84101 2.45118 2.64573 2.64646C2.45045 2.84174 2.45045 3.15835 2.64573 3.35363L5.29248 6.00038L2.64573 8.64713C2.45045 8.84241 2.45045 9.15902 2.64573 9.3543C2.84101 9.54958 3.15761 9.54958 3.35289 9.3543L5.99965 6.70755L8.6464 9.3543C8.84168 9.54958 9.15829 9.54958 9.35357 9.3543C9.54884 9.15902 9.54884 8.84241 9.35357 8.64713L6.70681 6.00038L9.35357 3.35363Z" fill="#194567" />
                            </svg>
                            1
                        </p>
                    </div>
                    <Variation
                        isBundle={true}
                        itemId={idx}
                        product={product}
                        isCoupon={isCoupon}
                        setVariation={(id_variation, attributes) => setVariation(idx, attributes)}
                        defaultAttributes={bundle}
                        setAttributeBundle={setAttributeBundle}
                    />
                </div>
            </div>
        </div>
    );
}

type BundleSelectorProps = {
    className?: string;
    bundle: { products: Record<string, Product>; };
    attributes: unknown[];
    isCoupon: boolean;
    setAttributeBundle: (attribute: Record<string, unknown>) => void;
};

const BundleSelector: React.FC<BundleSelectorProps> = ({
    className = "",
    bundle,
    attributes,
    isCoupon,
    setAttributeBundle,
}) => {
    let variation_items = [];
    for (let id in bundle.products) {
        variation_items.push(
            <BundleItem
                product={bundle.products[id]}
                isCoupon={isCoupon}
                setAttributeBundle={setAttributeBundle}
                idx={id}
                bundle={bundle}
                key={bundle.products[id].wordpress_id + id}
            />
        );
    }

    return (
        <div>
            {variation_items}
        </div>
    );
};

export default BundleSelector;